import { render } from "./UploadImage.vue?vue&type=template&id=7d857df8&scoped=true&ts=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import "./UploadImage.vue?vue&type=style&index=0&id=7d857df8&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d857df8"]])

export default __exports__